module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-miel.b56a1e0a.jpg";